import { saveAs } from "file-saver";

export function formatJsonForDownload(value: unknown): string {
  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  return JSON.stringify(value, null, 2);
}

export function downloadJsonFile(filename: string, contents: string): void {
  saveAs(new Blob([contents], { type: "application/json" }), filename);
}
